import { Sauna,SaunaImageRenderer } from '../materialImage2/';
import { BackrestLightType } from '../materialImage2/dist/saunaparts/BackRestLightType';
import ImageResolution from '../materialImage2/dist/saunaparts/ImageResolution';
import { Stove } from '../materialImage2/dist/saunaparts/Stove';
import { PanelMaterial } from '../materialImage2/src';
import { LayerImageRepository } from '../materialImage2/dist/LayerImageRepository';
import { BenchMaterial } from '../materialImage2/dist/saunaparts/BenchMaterial';
import { BenchModel } from    '../materialImage2/dist/saunaparts/BenchModel';
import { getBenchMaterial, getProfileMaterial, getPanelMaterial } from '../reducers/materialStore';
import { layerPath, stoves } from '../config';
import { getWebpAwareExtensionWithoutDot } from '../helpers/webpSupport';

let convertStateToMaterialRequest = (state: any): Sauna =>
{
    let benchModel = state.plan.hasBench ? convertBenchModel(state) : undefined;
    let productLine = state.plan.hasBench ? convertProductLine(state) : undefined;
    let benchMaterial = convertMaterial(state);
    let profileMaterial = convertProfileMaterial(state);
    let panelMaterial = converPanelMaterial(state);
    let stove = state.plan.hasStove ? convertStove(state) : undefined;
    return new Sauna(
        benchModel,
        productLine,
        benchMaterial,
        profileMaterial,
        benchModel?.size || "min",
        panelMaterial,
        parseBackRestLight(state.saunaLighting.selectedLight),
        state.saunaLighting.selectedLight.roofLight,
        false,
        state.saunaLighting.selectedLight.stoveLight,
        state.clientConfiguration.renderFrontWall,
        stove);
}

function convertBenchModel(state: any): BenchModel {
    let useOwnStove = !state.benchModel.shape.useCommonStove ||
        overrideGenericCommonStove(state.benchModel);  


    return new BenchModel(
        state.benchModel.shape.size,
        state.benchModel.shape.code,
        !useOwnStove,
        state.benchModel.shape.fullHeightGlassImage,
        state.benchModel.shape.halfHeightGlassImage
    )
}

function overrideGenericCommonStove(bench: any) {
    return bench.model.shapesWithOwnStoves && bench.model.shapesWithOwnStoves.find(s => s.code == bench.shape.code);
    

}



function convertProductLine(state: any): BenchProductLine {
    let model = Object.assign({},
        state.benchModel.model,
        { name: state.benchModel.model.name.replace(" ", "").replace("_","").toLowerCase() })
    return model;
}
let layerImageExtension = getWebpAwareExtensionWithoutDot();
let imageReposiry = new LayerImageRepository(layerPath, [new ImageResolution(960, 600), new ImageResolution(320, 200), new ImageResolution(1920, 1200)], layerImageExtension);
export function renderMaterialImage()
{
    return function (dispatch, getState) {

        dispatch(initMaterialImageUpdate());
        let state = getState();
        let renderer = new SaunaImageRenderer(imageReposiry);
        var sauna = convertStateToMaterialRequest(state);
        let dimensions = getImageDimensions();
        let promise = renderer.Render(sauna, new ImageResolution(dimensions.width, dimensions.height));
        promise.then(i => dispatch(materialImageComplete(i, sauna))).catch(e => console.log(e));
    }
}

const getImageDimensions = () => {
    let imageElement = document.getElementById("imagecontainer");
    return {
        width: Math.max(imageElement?.clientWidth, 960),
        height: Math.max(Math.floor(imageElement?.clientWidth / 1.6), 600)
    };
};
export const initMaterialImageUpdate = () => ({
    type: "MATERIALIMAGE_UPDATE_STARTED"
});

export const materialImageComplete = (canvas, parameters) => ({
    type: "MATERIALIMAGE_UPDATE_COMPLETE",
    canvas: canvas,
    parameters: parameters
});

export const updateMaterialImageOrSetPending = () => {
    return ((dispatch, getState) => {
        let state = getState();
        if (state.ui.materialImageShown) {
            dispatch(renderMaterialImage());
        }
        else {
            dispatch(setMateriaImageUpdatePending(true));
        }
    });
}


const setMateriaImageUpdatePending = (isUpdatePending) => {
    return {
        type: 'SET_UPDATEPENDING',
        isUpdatePending
    };
}





function convertMaterial(state: any): BenchMaterial {
    return getBenchMaterial(state, state.benchModel.material);;
}

function convertProfileMaterial(state: any) {
    return getProfileMaterial(state, state.benchModel.profileMaterial);
}

function convertStove(state: any): Stove {    
   return stoves.find(s => s.id === state.stove.stove);
}

function converPanelMaterial(state: any): PanelMaterial {
    return getPanelMaterial(state, state.paneling.panelMaterial) || placeHolderPanelMaterial;
}
let placeHolderPanelMaterial = {
    widthCode: 90,
    color: "grey"
};







function parseBackRestLight(selectedLight: any): any {
    if (selectedLight.benchLight) return BackrestLightType.Fiber;
    else if (selectedLight.linearLight || selectedLight.ledStripe) return BackrestLightType.LinearBar;
    else return BackrestLightType.None;
}
